export default {"src":"/_next/static/media/carsalt.3c483588.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};